/* CAD upgrade for the legacy scissor calculator. Do not modify calcScissor(). */
(function () {
  'use strict';
  const config = window.FGScissorCADConfig;
  const catalogue = window.FGActuatorSVGCatalogue;
  const engine = window.FGActuatorSVG;
  const host = document.querySelector('#tab-sim .right-col');
  if (!config || !catalogue || !engine || !host || typeof calcScissor !== 'function') return;
  const NS = 'http://www.w3.org/2000/svg';
  const entries = catalogue.entries.filter(e => e.motionType === 'rod' && Number.isFinite(e.closedMm) && Number.isFinite(e.openMm));
  const familyNames = [...new Set(entries.map(e => e.family))].sort((a, b) => a.localeCompare(b));
  const byId = new Map(entries.map(e => [e.id, e]));
  const escaping = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const compact = value => Number(value).toFixed(1).replace(/\.0$/, '');
  const forceOf = variant => {
    const match = String(variant.title || '').match(/([\d,]+(?:\.\d+)?)\s*lbs?\b/i);
    return match ? Number(match[1].replaceAll(',', '')) : 0;
  };
  const choices = entries.flatMap(entry => (entry.variants || [])
    .filter(variant => variant.available !== false && !(entry.pendingVariantIds || []).includes(variant.id))
    .map(variant => ({entry, variant, force: forceOf(variant)})));
  const usable = choices.filter(choice => choice.force > 0);
  const productUrl = choice => {
    const base = choice.entry.productUrl || ('https://www.firgelliauto.com/products/' + choice.entry.handle);
    return base + (base.includes('?') ? '&' : '?') + 'variant=' + encodeURIComponent(choice.variant.id);
  };
  const root = document.createElement('section');
  root.id = 'fg-scissor-cad';
  root.innerHTML = `
    <div class="sc-window">
      <div class="sc-heading"><span>Scissor lift · CAD actuator simulator</span><small>Existing inputs and force calculation preserved</small></div>
      <div class="sc-top">
        <div class="sc-fitted"><div class="sc-overline">Fitted actuator</div><div class="sc-name" id="sc-selected-name">Matching catalogue…</div><div class="sc-sub" id="sc-selected-details"></div><a id="sc-product-link" target="_blank" rel="noopener noreferrer" hidden>View selected SKU ↗</a></div>
      </div>
      <div class="sc-main">
        <div class="sc-controls">
          <div class="sc-tile"><strong id="sc-stroke-needed">—</strong><span>Stroke needed</span></div>
          <button type="button" class="sc-play" id="sc-raise">▲ Raise lift</button>
          <button type="button" id="sc-lower">▼ Lower lift</button>
          <div class="sc-travel-label">Travel <b id="sc-travel-pct">0%</b></div>
          <input id="sc-travel" type="range" min="0" max="100" value="0" aria-label="Lift travel percentage">
          <div class="sc-travel-label">Rotate view</div>
          <div class="sc-turns"><button type="button" id="sc-turn-left" aria-label="Rotate view counterclockwise">−90°</button><button type="button" id="sc-turn-right" aria-label="Rotate view clockwise">+90°</button></div>
          <button type="button" id="sc-turn-reset">Reset view</button>
        </div>
        <div class="sc-stage-wrap"><svg id="sc-svg" role="img" aria-label="Animated scissor lift with selected CAD actuator, fixed pivot, sliding pivot, and fixed base mount" viewBox="0 0 100 80" preserveAspectRatio="xMidYMid meet"><g id="sc-model"><g id="sc-structure"></g><g id="sc-cad-holder" transform="scale(0.03937007874015748)"></g><g id="sc-pins"></g></g></svg><div class="sc-stage-footer"><div class="sc-diagram-key" aria-label="Diagram key"><span><i class="sc-key-pivot"></i>Fixed pivot</span><span><i class="sc-key-slide"></i>Sliding pivot</span><span><i class="sc-key-mount"></i>Fixed actuator mount</span><span><i class="sc-key-actuator"></i>Selected CAD actuator</span></div><button class="sc-fit" type="button" id="sc-fit">Fit actuator</button></div></div>
        <div class="sc-force-card" id="sc-force-gauge" title="Live force at the current lift position. Dial colors indicate relative force demand, not an actuator safety rating."></div>
      </div>
      <div class="sc-chooser">
        <div class="sc-chooser-row">
          <div class="sc-select-control"><label for="sc-family">Actuator family</label><div class="sc-select-lock-row"><select id="sc-family" aria-label="Actuator family"></select><label class="sc-lock-option" for="sc-family-only"><input id="sc-family-only" type="checkbox"><span>Only use this model</span></label></div></div>
          <div class="sc-select-control"><label for="sc-stroke">Stroke</label><div class="sc-select-lock-row"><select id="sc-stroke" aria-label="Stroke"></select><label class="sc-lock-option" for="sc-stroke-only"><input id="sc-stroke-only" type="checkbox"><span>Only use this stroke</span></label></div></div>
          <label class="sc-variant-control" for="sc-variant">Force / model<select id="sc-variant"></select></label>
        </div>
        <div class="sc-options" id="sc-option-summary"></div>
        <p class="sc-foot"><strong>Mounting bracket allowance:</strong> The CAD actuator is drawn at its published pin-to-pin length, with its rear pin on an extended base rail and its rod pin on the sliding lower pivot. Bracket length is not included. Verify rail, bracket, pin and clearance dimensions; set travel limits when the selected stroke exceeds the required lift travel.</p>
        <div class="sc-status" id="sc-status" role="status"></div>
      </div>
    </div>`;
  const oldCanvas = host.querySelector('#cv');
  host.insertBefore(root, oldCanvas);
  const $ = id => root.querySelector('#' + id);
  const svg = $('sc-svg');
  const structure = $('sc-structure');
  const holder = $('sc-cad-holder');
  const pins = $('sc-pins');
  const familySelect = $('sc-family');
  const strokeSelect = $('sc-stroke');
  const variantSelect = $('sc-variant');
  let selected = null;
  let renderer = null;
  let drawingToken = 0;
  let drawingMessage = '';
  let selectionMode = 'auto';
  let forceDialMax = 0;

  // Match the live-force dial used by the other application calculators.
  // Keep its rounded range stable while the lift moves through a cycle.
  function chooseForceDialScale(demand, previous = 0) {
    if (!Number.isFinite(demand) || demand < 0) return previous || 1;
    if (previous > 0 && demand <= previous * .98 && demand >= previous * .3) return previous;
    const wanted = Math.max(demand * 1.2, .1) / 4;
    const decade = 10 ** Math.floor(Math.log10(wanted));
    return 4 * [1, 2, 2.5, 5, 10].find(step => step * decade >= wanted - 1e-12) * decade;
  }
  function renderForceDial(scale) {
    const point = degrees => [80 + 62 * Math.cos(degrees * Math.PI / 180), 83 + 62 * Math.sin(degrees * Math.PI / 180)];
    const arc = (from, to, color) => `<path d="M${point(from)} A62 62 0 0 1 ${point(to)}" fill="none" stroke="${color}" stroke-width="8"/>`;
    const ticks = Array.from({length: 5}, (_, index) => {
      const [x, y] = point(-210 + index * 60);
      return `<text x="${80 + (x - 80) * .72}" y="${86 + (y - 83) * .72}" text-anchor="middle">${(scale * index / 4).toLocaleString(undefined, {maximumFractionDigits: 2})}</text>`;
    }).join('');
    $('sc-force-gauge').innerHTML = `<svg viewBox="0 0 160 145" role="img" aria-label="Live actuator force dial">${arc(-210, -90, '#29b879')}${arc(-90, -30, '#ef992f')}${arc(-30, 30, '#ed6454')}${ticks}<g id="sc-force-needle" transform="translate(80 83)"><path d="M-6 0L52 0" stroke="#ed6454" stroke-width="3" stroke-linecap="round"/></g><circle cx="80" cy="83" r="5" fill="white" stroke="#526d7b"/><text id="sc-live-force" x="80" y="118" text-anchor="middle" class="sc-force-value"></text><text x="80" y="134" text-anchor="middle">lbf · LIVE FORCE</text></svg><span class="sc-force-note">Force Per Actuator</span><div class="sc-force-max"><span>Max force</span><strong id="sc-force-max">—</strong></div>`;
  }
  function updateForceDial(live, peak) {
    const scale = chooseForceDialScale(Math.max(live, peak), forceDialMax);
    if (scale !== forceDialMax) { forceDialMax = scale; renderForceDial(scale); }
    $('sc-force-needle').setAttribute('transform', `translate(80 83) rotate(${-210 + Math.min(Math.max(live, 0) / forceDialMax, 1) * 240})`);
    $('sc-live-force').textContent = live.toLocaleString();
    $('sc-force-max').textContent = peak.toLocaleString() + ' lbf';
    $('sc-force-gauge').querySelector('svg').setAttribute('aria-label', `Live actuator force ${live.toLocaleString()} lbf at the current lift position`);
  }

  // Shopify assets share a CDN directory. The existing catalogue URL is the
  // source of truth for all family artwork, including rolled CAD orientations.
  const drawingLoads = new Map();
  function loadDrawing(handle, roll = 0) {
    const key = handle + ':' + roll;
    if (!drawingLoads.has(key)) {
      const url = new URL(config.catalogueUrl, location.href);
      url.pathname = url.pathname.replace(/fg-lav-catalogue\.js$/, 'fg-lav-' + handle + '-' + roll + '.js');
      url.search = '?v=' + encodeURIComponent(catalogue.buildId || catalogue.builtOn || '1');
      drawingLoads.set(key, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url.href;
        script.onload = resolve;
        script.onerror = () => { drawingLoads.delete(key); reject(new Error('CAD artwork failed to load')); };
        document.head.append(script);
      }));
    }
    return drawingLoads.get(key);
  }

  function requirement() {
    const physics = calcScissor(0);
    return {physics, force: Math.ceil(physics.peakForce * (+document.getElementById('sf').value / 10) / actCount), stroke: physics.stroke};
  }
  function score(choice, need) {
    const strokeShort = Math.max(0, need.stroke - choice.entry.strokeIn);
    const forceShort = Math.max(0, need.force - choice.force);
    return (strokeShort > .01 ? 100000 + strokeShort * 1000 : 0) +
      (forceShort > 0 ? 50000 + forceShort * 20 : 0) +
      Math.max(0, choice.entry.strokeIn - need.stroke) * 100 +
      Math.max(0, choice.force - need.force) / 15;
  }
  function ranked(need, options = {}) {
    return usable.filter(choice => (!options.family || choice.entry.family === options.family) &&
      (!options.stroke || Math.abs(choice.entry.strokeIn - options.stroke) < .01))
      .sort((a, b) => score(a, need) - score(b, need) || a.entry.family.localeCompare(b.entry.family));
  }
  function manualChoice(need, options) {
    return ranked(need, options)[0] || choices.filter(choice =>
      (!options.family || choice.entry.family === options.family) &&
      (!options.stroke || Math.abs(choice.entry.strokeIn - options.stroke) < .01))
      .sort((a, b) => Math.abs(a.entry.strokeIn - need.stroke) - Math.abs(b.entry.strokeIn - need.stroke))[0];
  }
  function status(message, kind = '') {
    $('sc-status').textContent = message;
    $('sc-status').dataset.kind = kind;
  }
  function setSelected(choice, mode = 'manual') {
    if (!choice) return;
    const changed = !selected || selected.entry.id !== choice.entry.id;
    selected = choice;
    selectionMode = mode;
    fillSelectors();
    if (document.getElementById('tab-cmp').classList.contains('active')) cmpRender();
    if (changed) {
      renderer = null;
      holder.replaceChildren();
      const token = ++drawingToken;
      drawingMessage = 'Loading the selected CAD actuator…';
      loadDrawing(choice.entry.handle).then(() => {
        if (token !== drawingToken) return;
        renderer = engine.create(choice.entry.id);
        holder.replaceChildren(renderer.element);
        drawingMessage = '';
        render();
      }).catch(error => {
        if (token !== drawingToken) return;
        drawingMessage = error.message + '. The lift motion still shows the calculated geometry.';
        render();
      });
    }
    render();
  }
  function fillSelectors() {
    const family = selected?.entry.family || familyNames[0];
    familySelect.innerHTML = familyNames.map(name => `<option value="${escaping(name)}">${escaping(name)}</option>`).join('');
    familySelect.value = family;
    const strokes = [...new Set(entries.filter(entry => entry.family === family).map(entry => Math.round(entry.strokeIn * 100) / 100))].sort((a, b) => a - b);
    strokeSelect.innerHTML = strokes.map(value => `<option value="${value}">${compact(value)} in</option>`).join('');
    if (selected) strokeSelect.value = String(Math.round(selected.entry.strokeIn * 100) / 100);
    const variants = choices.filter(choice => choice.entry.id === selected?.entry.id);
    variantSelect.innerHTML = variants.map(choice => `<option value="${choice.variant.id}">${escaping(choice.variant.title || choice.variant.sku || 'Model ' + choice.variant.id)}</option>`).join('');
    if (selected) variantSelect.value = String(selected.variant.id);
  }
  function fitSelection() {
    const need = requirement();
    const filters = {};
    if ($('sc-family-only').checked) filters.family = familySelect.value;
    if ($('sc-stroke-only').checked) filters.stroke = Number(strokeSelect.value);
    const industrial = selectionMode === 'auto' && !filters.family && ranked(need, {...filters, family: 'Industrial Linear Actuators'})
      .find(item => item.force >= need.force && item.entry.strokeIn + .01 >= need.stroke);
    const choice = industrial || ranked(need, filters)[0];
    if (choice) setSelected(choice, 'auto');
    else status('No catalogue rod actuator is available with those locked options. Release a lock or select another model.', 'bad');
  }
  function selectFamily() {
    const need = requirement();
    const requestedFamily = familySelect.value;
    const lockedStroke = $('sc-stroke-only').checked ? Number(strokeSelect.value) : null;
    const options = {family: requestedFamily};
    if (Number.isFinite(lockedStroke)) options.stroke = lockedStroke;
    const choice = ranked(need, options).find(item => item.force + .01 >= need.force && item.entry.strokeIn + .01 >= need.stroke);
    if (choice) setSelected(choice, 'manual');
    else {
      familySelect.value = selected?.entry.family || requestedFamily;
      status(`No force-and-stroke match in ${requestedFamily}${Number.isFinite(lockedStroke) ? ` at the locked ${compact(lockedStroke)} in stroke` : ''}. The previous actuator and stroke lock were retained.`, 'bad');
    }
  }
  function selectStroke() {
    const need = requirement();
    setSelected(manualChoice(need, {family: familySelect.value, stroke: Number(strokeSelect.value)}), 'manual');
  }
  function selectVariant() {
    const choice = choices.find(item => item.entry.id === selected?.entry.id && item.variant.id === Number(variantSelect.value));
    if (choice) setSelected(choice, 'manual');
  }

  function node(tag, attributes = {}) {
    const el = document.createElementNS(NS, tag);
    Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, String(value)));
    return el;
  }
  function line(x1, y1, x2, y2, stroke, width, dash) {
    const el = node('line', {x1, y1, x2, y2, stroke, 'stroke-width': width, 'stroke-linecap': 'round'});
    if (dash) el.setAttribute('stroke-dasharray', dash);
    return el;
  }
  function textNode(x, y, value, size = 1.3, color = '#274b64', anchor = 'start') {
    const el = node('text', {x, y, fill: color, 'font-size': size, 'font-weight': 700, 'text-anchor': anchor, 'font-family': 'Inter, sans-serif'});
    el.textContent = value;
    return el;
  }
  function pin(x, y, color = '#286389') {
    return node('circle', {cx: x, cy: y, r: 0.85, fill: '#fff', stroke: color, 'stroke-width': 0.36});
  }
  function render() {
    if (!selected) return;
    const need = requirement();
    const physics = calcScissor(animPos);
    const angle = physics.currentAng * Math.PI / 180;
    // The scene follows the existing calculator's reported heights and widths.
    const stageHeight = physics.armLen * Math.sin(angle);
    const fullHeight = physics.nStages * stageHeight;
    const maxHeight = calcScissor(1).extendH;
    const width = 2 * physics.armLen * Math.cos(angle);
    const closedWidth = physics.collapseW;
    const baseY = maxHeight + 8;
    const rearX = closedWidth + selected.entry.closedMm / 25.4;
    const frontX = width;
    const minX = -5, maxX = rearX + 5, minY = -4, maxY = baseY + 8;
    const centerX = (minX + maxX) / 2, centerY = (minY + maxY) / 2;
    const quarter = ((modelRotation % 360) + 360) % 360;
    const rotated = quarter === 90 || quarter === 270;
    const viewWidth = rotated ? maxY - minY : maxX - minX;
    const viewHeight = rotated ? maxX - minX : maxY - minY;
    svg.setAttribute('viewBox', `${centerX - viewWidth / 2 - 2} ${centerY - viewHeight / 2 - 2} ${viewWidth + 4} ${viewHeight + 4}`);
    $('sc-model').setAttribute('transform', `rotate(${quarter},${centerX},${centerY})`);
    const parts = [];
    parts.push(node('rect', {x: -2, y: baseY + 1.1, width: rearX + 4, height: 1.1, rx: .3, fill: '#667e8c'}));
    parts.push(line(-2, baseY + 1, rearX + 2, baseY + 1, '#38576b', .35));
    parts.push(node('rect', {x: rearX - 1.1, y: baseY - 3, width: 2.2, height: 4.2, rx: .2, fill: '#aac5d5', stroke: '#355d76', 'stroke-width': .28}));
    parts.push(node('rect', {x: -.8, y: baseY - .7, width: 1.7, height: 1.6, rx: .25, fill: '#b4cad8', stroke: '#355d76', 'stroke-width': .25}));
    parts.push(node('rect', {x: frontX - 1.1, y: baseY - .7, width: 2.2, height: 1.6, rx: .25, fill: '#d7e5ee', stroke: '#355d76', 'stroke-width': .25}));
    for (let stage = 0; stage < physics.nStages; stage++) {
      const lower = baseY - stage * stageHeight;
      const upper = lower - stageHeight;
      parts.push(line(0, lower, width, upper, '#2d5672', .95));
      parts.push(line(width, lower, 0, upper, '#648ba5', .95));
      parts.push(pin(width / 2, (lower + upper) / 2, '#d28c45'));
      parts.push(pin(0, upper));
      parts.push(pin(width, upper));
    }
    const topY = baseY - fullHeight;
    parts.push(node('rect', {x: -1.6, y: topY - 1.1, width: width + 3.2, height: 1.1, rx: .28, fill: '#2f769f', stroke: '#194d6f', 'stroke-width': .25}));
    parts.push(node('rect', {x: width / 2 - 4.1, y: topY - 5.8, width: 8.2, height: 4.5, rx: .5, fill: '#d9b491', stroke: '#875e40', 'stroke-width': .25}));
    parts.push(textNode(width / 2, topY - 3.05, compact(physics.payload) + ' lbf load', 1.2, '#573a26', 'middle'));
    structure.replaceChildren(...parts);
    pins.replaceChildren(pin(0, baseY), pin(frontX, baseY), pin(rearX, baseY));

    const strokeOk = selected.entry.strokeIn + .01 >= need.stroke;
    const forceOk = selected.force + .01 >= need.force;
    if (renderer && strokeOk) {
      holder.style.display = '';
      try {
        renderer.placeBetween([rearX * 25.4, baseY * 25.4], [frontX * 25.4, baseY * 25.4]);
      } catch (error) {
        holder.style.display = 'none';
        drawingMessage = 'The selected CAD pin length cannot reach the current pivot spacing: ' + error.message;
      }
    } else holder.style.display = 'none';

    const currentForce = Math.ceil(physics.actForce / actCount);
    updateForceDial(currentForce, need.force);
    $('sc-stroke-needed').textContent = compact(need.stroke) + ' in';
    $('sc-travel').value = String(Math.round(animPos * 100));
    $('sc-travel-pct').textContent = Math.round(animPos * 100) + '%';
    $('sc-raise').textContent = anim && aDir > 0 ? 'Ⅱ Pause' : '▲ Raise lift';
    $('sc-lower').textContent = anim && aDir < 0 ? 'Ⅱ Pause' : '▼ Lower lift';
    $('sc-selected-name').textContent = selected.entry.family;
    $('sc-selected-details').textContent = `${compact(selected.entry.strokeIn)} in stroke · ${selected.variant.title || selected.variant.sku || selected.force + ' lbf'} · ${compact(selected.entry.closedMm / 25.4)} in retracted pin length${selected.variant.sku ? ' · SKU ' + selected.variant.sku : ''}`;
    const product = $('sc-product-link');
    product.hidden = false;
    product.href = productUrl(selected);
    $('sc-option-summary').textContent = `${familyNames.length} compatible rod families · ${entries.length} CAD drawings available`;
    if (drawingMessage) status(drawingMessage, 'warn');
    else if (!selected.force) status(`The ${selected.entry.family} CAD drawing is available, but this catalogue entry has no published force rating. The actuator cannot be marked as a load match; verify its exact product specification.${strokeOk ? '' : ' Its selected stroke is also below the required travel.'}`, 'warn');
    else if (!strokeOk && !forceOk) status(`Selected model is short on stroke (${compact(selected.entry.strokeIn)} vs ${compact(need.stroke)} in) and force (${selected.force} vs ${need.force} lbf). Select another model or press Fit actuator. The CAD is hidden rather than drawn at an impossible length.`, 'bad');
    else if (!strokeOk) status(`Selected stroke is too short: ${compact(selected.entry.strokeIn)} in available vs ${compact(need.stroke)} in needed. The CAD is hidden rather than shown at an impossible mounting distance.`, 'bad');
    else if (!forceOk) status(`Selected force is too low: ${selected.force} lbf rated vs ${need.force} lbf needed per actuator. The drawing is geometric only; do not use this model for the calculated load.`, 'bad');
    else status(`Found force-and-stroke match. The lift moves ${compact(need.stroke)} in and uses ${compact(need.stroke)} in of the selected ${compact(selected.entry.strokeIn)} in stroke. ${selected.entry.strokeIn > need.stroke + .1 ? 'Set travel limits for the unused stroke. ' : ''}Mounting space and interference still require engineering checks.${actCount > 1 ? ' Verify synchronized control and feedback compatibility for multiple actuators.' : ''}`);
  }

  function update() {
    if (selectionMode === 'auto') fitSelection();
    else render();
  }
  const previousDraw = drawCanvas;
  drawCanvas = function () { previousDraw(); render(); };
  const previousUpdate = simUpdate;
  simUpdate = function () { previousUpdate(); update(); if (document.getElementById('tab-sel').classList.contains('active')) selUpdate(); if (document.getElementById('tab-cmp').classList.contains('active')) cmpRender(); };
  $('sc-fit').addEventListener('click', fitSelection);
  $('sc-family-only').addEventListener('change', fitSelection);
  $('sc-stroke-only').addEventListener('change', fitSelection);
  familySelect.addEventListener('change', selectFamily);
  strokeSelect.addEventListener('change', selectStroke);
  variantSelect.addEventListener('change', selectVariant);
  $('sc-travel').addEventListener('input', event => {
    if (anim) toggleAnim();
    animPos = Number(event.target.value) / 100;
    drawCanvas();
  });
  function play(direction) {
    if (anim) { toggleAnim(); if (aDir === direction) {render(); return;} }
    aDir = direction;
    if (direction > 0 && animPos >= .98) animPos = 0;
    if (direction < 0 && animPos <= .02) animPos = 1;
    toggleAnim();
    render();
  }
  $('sc-raise').addEventListener('click', () => play(1));
  $('sc-lower').addEventListener('click', () => play(-1));
  $('sc-turn-left').addEventListener('click', () => { modelRotation = (modelRotation + 270) % 360; simUpdate(); });
  $('sc-turn-right').addEventListener('click', () => { modelRotation = (modelRotation + 90) % 360; simUpdate(); });
  $('sc-turn-reset').addEventListener('click', () => { modelRotation = 0; simUpdate(); });

  // The older Selector tab used approximate family ranges and omitted many
  // families. It now lists actual catalogue variants without changing its
  // requirement sliders or the underlying scissor-force calculation.
  selUpdate = function () {
    const force = Number(document.getElementById('sel_f').value);
    const stroke = Number(document.getElementById('sel_s').value);
    const multiplier = Number(document.getElementById('sel_sf').value) / 10;
    const feedback = document.getElementById('sel_fb').checked;
    document.getElementById('sel_fV').textContent = force + ' lbf per actuator';
    document.getElementById('sel_sV').textContent = stroke + ' in';
    document.getElementById('sel_sfV').textContent = multiplier.toFixed(1) + '×';
    const need = {force: Math.ceil(force * multiplier), stroke};
    const matches = ranked(need).filter(choice => !feedback || /feedback|optical/i.test(choice.entry.handle));
    const unique = [];
    const seen = new Set();
    for (const choice of matches) {
      // One best model per family keeps the list useful without hundreds of
      // near-identical voltage/force variants. All individual options remain
      // available through the simulator selectors.
      const key = choice.entry.family;
      if (!seen.has(key)) {seen.add(key); unique.push(choice);}
    }
    document.getElementById('sel_cnt').textContent = unique.length + ' actuator families';
    document.getElementById('sel_cmpBtn').style.display = 'none';
    document.getElementById('sel_res').innerHTML = `<div class="sc-catalogue-note">Best CAD-derived model from each force-rated rod family. Force and stroke are checked independently. Choose a card to inspect its actual SVG and all stroke/force variants in the simulator. Unrated CAD families remain available in the simulator menu. ${feedback ? 'Feedback filter includes the feedback/optical families; confirm controller compatibility for your variant.' : ''}</div><div class="sc-catalogue-list">${unique.map((choice, index) => {
      const fits = choice.force >= need.force && choice.entry.strokeIn + .01 >= need.stroke;
      return `<div class="act-card" data-sc-choice="${index}" style="border-left:4px solid ${fits ? '#20a871' : '#e9a54b'}"><div class="act-card-head"><div class="act-card-name">${escaping(choice.entry.family)}</div><b style="font-size:10px;color:${fits ? '#16865a' : '#aa6721'}">${fits ? 'FORCE + STROKE MATCH' : 'CLOSEST OPTION'}</b></div><div class="act-card-specs"><div class="act-card-spec"><div class="lbl">Force</div><div class="val">${choice.force} lbf</div></div><div class="act-card-spec"><div class="lbl">Stroke</div><div class="val">${compact(choice.entry.strokeIn)} in</div></div><div class="act-card-spec"><div class="lbl">Retracted pin length</div><div class="val">${compact(choice.entry.closedMm / 25.4)} in</div></div></div><div style="font-size:10px;color:#617889;margin-top:5px">${escaping(choice.variant.title || choice.variant.sku || '')} · Click to view CAD drawing</div></div>`;
    }).join('')}</div>`;
    document.getElementById('sel_res').querySelectorAll('[data-sc-choice]').forEach(card => card.addEventListener('click', () => {
      setSelected(unique[Number(card.dataset.scChoice)], 'manual');
      switchTab('sim');
    }));
  };
  toSelector = function () {
    const ph = calcScissor(0);
    const forceSlider = document.getElementById('sel_f');
    const strokeSlider = document.getElementById('sel_s');
    const perActuator = Math.ceil(ph.peakForce / actCount / 10) * 10;
    forceSlider.max = String(Math.max(2500, perActuator));
    strokeSlider.max = String(Math.max(60, Math.ceil(ph.stroke)));
    forceSlider.nextElementSibling.lastElementChild.textContent = Number(forceSlider.max).toLocaleString() + ' lbf';
    strokeSlider.nextElementSibling.lastElementChild.textContent = strokeSlider.max + ' in';
    forceSlider.value = String(perActuator);
    strokeSlider.value = String(Math.ceil(ph.stroke));
    document.getElementById('sel_sf').value = document.getElementById('sf').value;
    switchTab('sel');
  };
  cmpRender = function () {
    const need = requirement();
    const alternatives = ranked(need).filter(choice => choice.entry.family !== selected?.entry.family);
    const picks = [selected];
    for (const choice of alternatives) {
      if (picks.length >= 3) break;
      if (!picks.some(item => item.entry.family === choice.entry.family)) picks.push(choice);
    }
    document.getElementById('cmp_slots').innerHTML = `<div class="section-title">CAD catalogue comparison</div><div class="sc-catalogue-note">The selected actuator is compared with the two closest alternatives from different families. Change the simulator model to compare another option.</div><button class="btn-primary" type="button" id="sc-back-to-sim" style="background:#1188c4;color:#fff">Return to simulator</button>`;
    document.getElementById('sc-back-to-sim').addEventListener('click', () => switchTab('sim'));
    const rows = [
      ['Family', item => item.entry.family],
      ['Model', item => item.variant.title || item.variant.sku || 'Catalogue variant'],
      ['Force rating', item => item.force ? item.force + ' lbf' : 'Not listed in CAD catalogue'],
      ['Stroke', item => compact(item.entry.strokeIn) + ' in'],
      ['Retracted pin length', item => compact(item.entry.closedMm / 25.4) + ' in'],
      ['Fit to current lift', item => item.force >= need.force && item.entry.strokeIn + .01 >= need.stroke ? 'Force and stroke match' : 'Below force or stroke requirement'],
      ['Product', item => `<a href="${escaping(productUrl(item))}" target="_blank" rel="noopener noreferrer">View product ↗</a>`],
    ];
    document.getElementById('cmp_area').innerHTML = `<div class="sc-catalogue-note">Current requirement: <b>${need.force} lbf per actuator</b> and <b>${compact(need.stroke)} in</b> working stroke. Confirm speed, duty cycle, mounting and controls before purchase.</div><div style="overflow-x:auto"><table class="sc-compare-table" style="width:100%;border-collapse:collapse;font-size:12px"><thead><tr><th style="text-align:left;padding:9px;border:1px solid #d9e7f0;background:#eff8fd">Spec</th>${picks.map((_, index) => `<th style="padding:9px;border:1px solid #d9e7f0;background:#eff8fd">${index ? 'Alternative ' + index : 'Selected actuator'}</th>`).join('')}</tr></thead><tbody>${rows.map(([label, value]) => `<tr><th style="text-align:left;padding:9px;border:1px solid #d9e7f0">${label}</th>${picks.map(item => `<td style="padding:9px;border:1px solid #d9e7f0;text-align:center">${label === 'Product' ? value(item) : escaping(value(item))}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`;
  };
  const start = requirement();
  const forceSlider = document.getElementById('sel_f');
  const strokeSlider = document.getElementById('sel_s');
  const perActuator = Math.ceil(start.physics.peakForce / actCount / 10) * 10;
  forceSlider.max = String(Math.max(2500, perActuator));
  strokeSlider.max = String(Math.max(60, Math.ceil(start.stroke)));
  forceSlider.nextElementSibling.lastElementChild.textContent = Number(forceSlider.max).toLocaleString() + ' lbf';
  strokeSlider.nextElementSibling.lastElementChild.textContent = strokeSlider.max + ' in';
  forceSlider.value = String(perActuator);
  strokeSlider.value = String(Math.ceil(start.stroke));
  document.getElementById('sel_sf').value = document.getElementById('sf').value;
  // The legacy Selector and Compare views used a second, independent set of
  // requirements. The standard views below always use the live simulator.
  const matchesPanel = document.querySelector('#tab-sel .right-col');
  const specsPanel = document.querySelector('#tab-cmp .right-col');
  matchesPanel.insertAdjacentHTML('afterbegin', '<div class="sc-standard-head"><h2>Actuator matches</h2><p>These options use the force and stroke calculated from the current Scissor Lift inputs.</p><label><input id="sc-match-feedback" type="checkbox"> Require verified feedback</label></div>');
  matchesPanel.querySelector('#sc-match-feedback').addEventListener('change', selUpdate);
  const option = choice => ({
    name: choice.entry.family,
    variant: choice.variant.title || choice.variant.sku || 'Catalogue variant',
    specs: `Rated force ${choice.force} lbf | stroke ${compact(choice.entry.strokeIn)} in | retracted ${compact(choice.entry.closedMm / 25.4)} in`,
    limits: choice.entry.strokeIn > requirement().stroke + .1 ? 'Set travel limits for unused stroke. Confirm the final mounting envelope.' : 'Confirm the final mounting envelope.',
    url: productUrl(choice),
  });
  selUpdate = function () {
    const need = requirement(), feedback = matchesPanel.querySelector('#sc-match-feedback').checked;
    const matches = ranked(need).filter(choice => choice.force >= need.force && choice.entry.strokeIn + .01 >= need.stroke && (!feedback || /feedback|optical/i.test(choice.entry.handle)));
    const unique = [], seen = new Set();
    for (const choice of matches) if (!seen.has(choice.entry.family)) {seen.add(choice.entry.family); unique.push(choice);}
    document.getElementById('sel_cnt').textContent = unique.length + ' matching families';
    document.getElementById('sel_res').innerHTML = unique.length ? `<p class="sc-catalogue-note">Calculated requirement: <strong>${need.force} lbf per actuator</strong> and <strong>${compact(need.stroke)} in stroke</strong>. The family menu in Simulator contains all published CAD options, including entries without a verified force rating.</p><div class="sc-catalogue-list">${unique.map((choice, index) => `<article class="act-card" data-sc-choice="${index}"><div class="act-card-head"><div class="act-card-name">${escaping(choice.entry.family)}</div><b>FORCE + STROKE MATCH</b></div><div class="act-card-specs"><div class="act-card-spec"><div class="lbl">Force rating</div><div class="val">${choice.force} lbf</div></div><div class="act-card-spec"><div class="lbl">Stroke</div><div class="val">${compact(choice.entry.strokeIn)} in</div></div><div class="act-card-spec"><div class="lbl">Retracted pin length</div><div class="val">${compact(choice.entry.closedMm / 25.4)} in</div></div></div><p>${escaping(choice.variant.title || choice.variant.sku || '')}</p><a href="${escaping(productUrl(choice))}" target="_blank" rel="noopener noreferrer">View exact model ↗</a><button type="button" data-sc-use="${index}">Show in simulator</button></article>`).join('')}</div>` : '<div class="sc-catalogue-note">No force-and-stroke match in the published CAD catalogue. Reduce the demand or revise the lift geometry; do not use an undersized actuator.</div>';
    document.getElementById('sel_res').querySelectorAll('[data-sc-use]').forEach(button => button.addEventListener('click', () => {
      setSelected(unique[Number(button.dataset.scUse)], 'manual');
      switchTab('sim');
    }));
  };
  function makeReport() {
    const need = requirement(), chosen = selected, svg = document.getElementById('sc-svg').cloneNode(true);
    const box = svg.viewBox.baseVal;
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg'); svg.setAttribute('width', box.width); svg.setAttribute('height', box.height);
    const fields = [['Load weight', 'lW', 'lbf'], ['Arm length', 'aL', 'in'], ['Number of stages', 'nS', ''], ['Collapsed angle', 'aMin', 'deg'], ['Extended angle', 'aMax', 'deg'], ['Platform weight', 'pW', 'lbf'], ['Friction / resistance', 'fR', '%'], ['Arm weight per stage', 'aW', 'lbf'], ['Safety factor', 'sf', 'tenths']];
    const rows = fields.map(([label, id, unit]) => [label, document.getElementById(id).value + (unit === 'tenths' ? ' / 10' : unit ? ' ' + unit : '')]);
    const allMatches = ranked(need).filter(choice => choice.force >= need.force && choice.entry.strokeIn + .01 >= need.stroke).slice(0, 3);
    return {
      title: 'FIRGELLI Scissor Lift Calculator', subtitle: 'Customer design snapshot and catalogue actuator selection', created: new Date().toISOString(), url: location.href, units: 'Inches / lbf', position: Math.round(animPos * 100) + '%', driveNote: 'The selected CAD actuator is placed between the base mount and the moving lower pivot.',
      scene: {xml: new XMLSerializer().serializeToString(svg), width: box.width, height: box.height}, chart: null, legend: '',
      summary: [['Force per actuator', need.force + ' lbf'], ['Stroke needed', compact(need.stroke) + ' in'], ['Actuator count', String(actCount)], ['Selected model', chosen ? chosen.entry.family + ' · ' + (chosen.variant.title || chosen.variant.sku || '') : 'No selection']],
      settings: [['Number of actuators', String(actCount)], ['Installation rotation', modelRotation + ' deg'], ['Animation position', Math.round(animPos * 100) + '%']],
      groups: [{name: 'Scissor lift inputs', rows}],
      results: [['Scissor drive', need.force + ' lbf', compact(need.stroke) + ' in', chosen ? compact(chosen.entry.closedMm / 25.4) + ' in' : 'No selection', chosen ? compact(chosen.entry.openMm / 25.4) + ' in' : 'No selection']],
      insights: [`Maximum demand occurs near the collapsed position. The existing scissor-lift force calculation and safety factor remain unchanged.`, `Selected actuator force rating: ${chosen?.force || 0} lbf. Check mounting dimensions, travel limits, duty cycle and synchronized control for multiple drives.`],
      closestOptions: [], matches: [{channel: 'Scissor drive · first ' + allMatches.length + ' catalogue options', items: allMatches.map(option)}], comparisons: [],
      assumptions: ['This report preserves the calculator inputs and existing force method. The CAD drawing shows catalogue geometry at the current simulated position.', 'Confirm hardware, mounting brackets, pin clearance, side loads, loaded speed and controls before purchasing.'],
    };
  }
  let pdfLoader = null;
  function loadPdfTools() {
    if (pdfLoader) return pdfLoader;
    const load = url => new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src = url;
      script.onload = resolve; script.onerror = () => reject(new Error('PDF tools could not load. Please try again.'));
      document.head.append(script);
    });
    pdfLoader = (async () => { if (!window.PDFLib) await load(config.pdfLibrary); if (!window.FGApplicationPDF) await load(config.pdfScript); })().catch(error => {pdfLoader = null; throw error;});
    return pdfLoader;
  }
  async function downloadPdf(button) {
    const status = specsPanel.querySelector('#sc-pdf-status');
    button.disabled = true; button.textContent = 'Creating PDF…'; status.textContent = '';
    try {
      await loadPdfTools();
      const bytes = await window.FGApplicationPDF.create(makeReport());
      const url = URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}));
      const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'firgelli-scissor-lift-design.pdf';
      document.body.append(anchor); anchor.click(); anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      status.textContent = 'PDF downloaded.';
    } catch (error) { status.textContent = error.message || 'PDF download failed.'; }
    finally {button.disabled = false; button.textContent = 'Download PDF';}
  }
  cmpRender = function () {
    const need = requirement(), chosen = selected;
    const items = [
      ['Peak force per actuator', need.force + ' lbf'],
      ['Stroke needed', compact(need.stroke) + ' in'],
      ['Actuator count', String(actCount)],
      ['Scissor stages', document.getElementById('nS').value],
      ['Collapsed / extended angle', document.getElementById('aMin').value + '° / ' + document.getElementById('aMax').value + '°'],
      ['Selected family', chosen?.entry.family || 'None'],
      ['Selected force / model', chosen ? (chosen.variant.title || chosen.variant.sku || chosen.force + ' lbf') : 'None'],
      ['Selected stroke', chosen ? compact(chosen.entry.strokeIn) + ' in' : 'None'],
      ['Retracted / extended pin length', chosen ? compact(chosen.entry.closedMm / 25.4) + ' / ' + compact(chosen.entry.openMm / 25.4) + ' in' : 'None'],
    ];
    document.getElementById('cmp_area').innerHTML = `<div class="sc-standard-head"><div><h2>Technical specs</h2><p>Calculated requirements and the currently selected catalogue actuator.</p></div><div class="sc-pdf-action"><button type="button" id="sc-download-pdf">Download PDF</button><span id="sc-pdf-status" role="status"></span></div></div><div class="sc-spec-grid">${items.map(([label, value]) => `<article><span>${escaping(label)}</span><strong>${escaping(value)}</strong></article>`).join('')}</div><p class="sc-catalogue-note">The PDF includes these results, all simulator inputs, the current CAD drawing and matching product options. Verify brackets, travel limits, duty cycle, loaded speed and synchronization separately.</p>`;
    document.getElementById('sc-download-pdf').addEventListener('click', event => downloadPdf(event.currentTarget));
  };
  fitSelection();
  selUpdate();
})();
